module.exports = __webpack_public_path__ + "static/media/KenzieOnline.18e5e5ae.png";